import { Injectable } from '@angular/core';
import { SignatureV4, Headers } from 'signature-v4';
import * as cryptoJS from 'crypto-js';

import { environment } from '../../../environments/environment';

@Injectable()
export class AwsSignerService {
  private apiKey: string;

  constructor() {
    this.apiKey = environment.cesAPI.apiKey;
  }

  getAwsHeader(url, method, body?) {
    const requestOptions = {
      url,
      method,
      payload: '',
      headers: new Headers({ 'Content-Type': 'application/json' })
    };

    if (body) {
      requestOptions.payload = JSON.stringify(body);
    }


    const signer = new SignatureV4(requestOptions, 'execute-api', localStorage.getItem('region-id'));
    const awsHeaders = signer.createHeaders(sessionStorage.getItem('accessKeyId'), sessionStorage.getItem('secretAccessKey'), sessionStorage.getItem('sessionToken'));

    return {
      'x-api-key': this.apiKey,
      'X-Amz-Date': awsHeaders.get('X-Amz-Date'),
      'Authorization': awsHeaders.get('Authorization'),
      'x-amz-security-token': awsHeaders.get('x-amz-security-token')
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/aws-signer/aws-signer.service.ts